import * as R from 'ramda';
import { message } from 'antd';
import { connect } from 'react-redux';
import { mapProps, branch, renderComponent, withState, lifecycle } from 'recompose';

import { filterUsers } from './utils';
import ListUsersComp from './list-users-comp';
import { USER_ROLES } from '../../../api/constants/';
import Spinner from '../../../components/ui-helpers/spinner';
import { inviteUserFetched } from '../../../redux/actions/invitations';
import { handleCancelInvitation } from '../../../redux/thunk/invitations';

import {
  fetchUsers,
  handleUserDelete,
  handleUserRestore,
  handleChangeUserRole,
} from '../../../redux/thunk/users';

import * as ApikoApi from '../../../api/apiko-api';
import { getAuthorizedUser } from '../../../redux/selectors';
import { getResErrorMsg, sortDataByAlphabet } from '../../../utils';

const mapStateToProps = (state, { isDeleted }) => {
  const {
    users: { items },
    invitationsUser: { isInviteUser },
  } = state;

  return ({
    isInviteUser,
    authorizedUser: getAuthorizedUser(state),
    users: sortDataByAlphabet('fullName', filterUsers(items, isDeleted)),
  });
};

export const ListUsers = R.compose(
  connect(
    mapStateToProps,
    {
      fetchUsers,
      handleUserDelete,
      handleUserRestore,
      handleChangeUserRole,
      handleCancelInvitation,
      inviteUserFetched,
    },
  ),
  lifecycle({
    componentDidMount() {
      if (R.isEmpty(this.props.users)) {
        this.props.fetchUsers();
      }
    },
    componentWillReceiveProps(props) {
      if (props.isInviteUser) {
        this.props.fetchUsers();
        this.props.inviteUserFetched();
      }
    },
  }),
  branch(
    ({ isFetching, users }) => isFetching && users.length === 0,
    renderComponent(Spinner),
  ),
  withState('isSwitchedAdmin', 'setIsSwitchedAdmin', false),
  mapProps(({
    users,
    authorizedUser,
    ...actions
  }) => ({
    users,
    authorizedUser,
    onDeleteUser: id => actions.handleUserDelete(id),
    onRestoreUser: id => actions.handleUserRestore(id),
    onCancelInvitation: id => actions.handleCancelInvitation(id),
    onChangeUserRole: id => actions.handleChangeUserRole(id, { role: USER_ROLES.ADMIN }),
    reInviteUser: id => ApikoApi.reInviteUser(id)
      .then(() => message.success('Invitation successfully sent to user via email'))
      .catch(error => message.error(getResErrorMsg(error))),
  })),
)(ListUsersComp);



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/list-users.js